import { render, staticRenderFns } from "./OrdersCreate.vue?vue&type=template&id=7abbcb15&scoped=true&"
import script from "./OrdersCreate.vue?vue&type=script&lang=js&"
export * from "./OrdersCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCreate.vue?vue&type=style&index=0&id=7abbcb15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abbcb15",
  null
  
)

export default component.exports